import React from 'react';
import projectsData from './projects.json'; // Correct path to JSON file
import './ProjectList.css';
import img from "../../images/periodtracker.jpg";
import img2 from "../../images/swastha.jpg";
import img3 from "../../images/recipe.jpg";


const ProjectList = () => {
  return (
    <>
    <h2 className='project-heading'>My Projects:</h2>
    <div id="projects" className="project-list">
        <div  className="project-card">
          <img src={img} alt="Menstrual Period Tracker" className="project-image" />
          <div className="project-info">
            <h3>Menstrual Period Tracker</h3>
            <p>To predict the period date using Arima model.</p>
            <div className="project-links">
              <a href= "https://github.com/Nis13/PeriodTracker-usingArima" target="_blank" rel="noopener noreferrer">GitHub</a>
            </div>
          </div>
        </div>
        <div className="project-card">
        <img src={img2} alt="" className="project-image" />
        <div className="project-info">
          <h3>SwasthaMe</h3>
          <p>A website to suggest diet using Nepali food</p>
          <div className="project-links">
            <a href="https://github.com/Nis13/SwasthaME" target="_blank" rel="noopener noreferrer">GitHub</a>
          </div>
        </div>
      </div>
      <div className="project-card">
      <img src={img3} alt="" className="project-image" />
      <div className="project-info">
        <h3>Recipe Finder</h3>
        <p>To find the foods with their recipes.</p>
        <div className="project-links">
          <a href="https://github.com/Nis13/Code_like_her/tree/main/recipe-finder" target="_blank" rel="noopener noreferrer">GitHub</a>
        </div>
      </div>
    </div>
    </div>
    </>
  );
};

export default ProjectList;
